import MuiTable, { TableProps as MuiTableProps } from '@material-ui/core/Table';

export type DSTableProps = MuiTableProps;

export const DSTable = MuiTable;
